import { render, staticRenderFns } from "./Asset-Overview-Detail.vue?vue&type=template&id=c06d8938&scoped=true&lang=pug"
import script from "./Asset-Overview-Detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Overview-Detail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Asset-Overview-Detail.vue?vue&type=style&index=0&id=c06d8938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d8938",
  null
  
)

export default component.exports